module.exports = __webpack_public_path__ + "static/media/instructions_first.b85ae6fe.mp3";